module.exports = __webpack_public_path__ + "static/img/4.a7b955df.png";